<template>
  <div>
    <widgets-dialogs
      ref="widgetDialogs"
      :widgets="form.widgets"
      :errors="errors.widgets"
    />
    <revisions-dialog ref="revisionsDialog" @submit="loadRevision" />
    <revisions-alert :pendingRevision="pendingRevision" />
    <form-wrapper @submit="onSubmit">
      <div slot="box" v-loading="loading">
        <component-compiler
          v-for="(component, i) in getFields()"
          :content="component"
          :key="`form-${i}`"
        />
      </div>
      <form-nav :loading="loading" slot="navbar">
        <component-compiler
          v-for="(component, i) in getNavButtons()"
          :content="component"
          :key="`nav-button-${i}`"
        />
      </form-nav>
    </form-wrapper>
  </div>
</template>
<script>
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import WidgetsDialogs from '@/components/widgets/WidgetsDialogs'
import LivePreviewMixin from '@/crudBases/form/LivePreviewMixin'
import RevisionsDialog from '@/components/revisions/RevisionsDialog'
import RevisionsMixin from '@/crudBases/form/RevisionsMixin'
import RevisionsAlert from '@/crudBases/form/RevisionsAlert'

export default {
  extends: FormMixin,
  mixins: [LivePreviewMixin, RevisionsMixin],
  components: {
    WidgetsDialogs,
    RevisionsDialog,
    RevisionsAlert
  },
  data() {
    return {
      selectedTab: 'general',
      form: {
        widgets: []
      },
      oldFormValue: '',
      arrayFields: []
    }
  },
  created() {
    this.fixArrayFields()
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(value) {
        const formChanged = this.oldFormValue !== JSON.stringify(value)
        if (formChanged) {
          this.oldFormValue = JSON.stringify(value)
          this.fetchPreview()
        }
      }
    }
  },
  computed: {
    revisionsAvailable() {
      return this.lookupParams
    }
  },
  methods: {
    fixArrayFields() {
      this.arrayFields.forEach(field => {
        if (!Array.isArray(this.form[field])) {
          this.$set(this.form, field, [])
        }
      })
    },
    getNavButtons() {
      const buttons = []

      buttons.push(this.getCancelButton())

      if (this.revisionsAvailable) {
        buttons.push(this.getRevisionsDropdown())
      } else {
        buttons.push(this.getSubmitButton({}))
      }

      return buttons
    },
    getSubmitButton({ customSubmitMethod, label = 'Zatwierdź' }) {
      return {
        component: 'el-button',
        attrs: {
          type: 'primary'
        },
        listeners: {
          click: customSubmitMethod || this.onSubmit
        },
        innerText: label
      }
    },
    getCancelButton() {
      return {
        component: 'router-link',
        attrs: {
          to: { ...this.redirectRoute, query: this.$route.query }
        },
        condition: this.redirectRoute,
        children: [
          {
            component: 'el-button',
            innerText: 'Anuluj'
          }
        ]
      }
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          attrs: {
            stretch: true,
            value: this.selectedTab
          },
          listeners: {
            input: value => (this.selectedTab = value)
          },
          children: [
            this.getGeneralTab(),
            this.getPreviewTab(),
            this.getWidgetsTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne',
          name: 'general'
        },
        children: this.getGeneralFields()
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety',
          name: 'widgets'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getGeneralFields() {
      return []
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title']
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea'
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title']
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea'
          })
        ]
      }
    }
  }
}
</script>
